// extracted by mini-css-extract-plugin
export default {"file_detail":"index_file_detail__+JsRc","ten":"index_ten__uKdxE","release_note":"index_release_note__zoJYi"};